import '@styles/pages/search.scss';

import { initSelectionBusHandler } from '@molecules/selection-bus-handler';
import { selectionSliderManager } from '@molecules/selection-slider-manager';
import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';

window.googlePlacesHelpers = googlePlacesHelpers;

initSelectionBusHandler();
selectionSliderManager();
